import { Pipe, PipeTransform } from '@angular/core';
import { StatusSchedulingEnum } from '../../enum/medical-record/status-scheduling.enum';
import { DateTimeStruct } from '../../services/structs/orchestrator-patient/date-time.struct';
import { MedicalProcedureCheckStruct } from '../../services/structs/orchestrator-patient/medical-procedure-check.struct';
import { FrequencyEnum } from '../../enum/medical-record/frequency.enum';
import { PrescriptionStatusEnum } from '../../enum/prescription-status.enum';
import { PrescriptionMedicineCheckStruct } from '../../services/structs/pharmacy/prescription-medicine-check.struct';
import { PrescriptionSolutionCheckStruct } from '../../services/structs/pharmacy/prescription-solution-check.struct';

@Pipe({
    name: 'filterStatusPrescriptionScheduling',
    pure: false,
    standalone: false
})
export class FilterStatusPrescriptionSchedulingPipe implements PipeTransform {

  transform(value: any, idPrescriptionStatus: number, isChecking: boolean, idFrequency: number, functionName: string, isProcedureRecurring?: boolean, ...args: [DateTimeStruct[], string, number]): any {
    switch (functionName) {
      case 'getStatusPrescription':
        return this.getStatusPrescription(value, idPrescriptionStatus, isChecking, idFrequency, ...args);
      case 'getStatusPrescriptionSolution':
        return this.getStatusPrescriptionSolution(value, idPrescriptionStatus, isChecking, idFrequency, ...args);
      case 'getStatusProcedure':
        return this.getStatusProcedure(value, isChecking, isProcedureRecurring, ...args);
      default:
        throw new Error(`Função ${functionName} não implementada.`);
    }
  }

  getStatusPrescription(listPrescriptionCheck: PrescriptionMedicineCheckStruct[], idPrescriptionStatus: number, isChecking: boolean, idFrequency: number, listDateTime: DateTimeStruct[], date: string, hour: number): string {
    if (idPrescriptionStatus === PrescriptionStatusEnum.Suspenso)
      return 'hide';
    else if ((!listPrescriptionCheck || listPrescriptionCheck.length == 0)
      && listDateTime && listDateTime[0].date == date
      && listDateTime[0].hour[0] == hour) {
      if (idFrequency && idFrequency == FrequencyEnum.agora) {
        if (!isChecking)
          return 'hide';
        else if (listPrescriptionCheck?.[-1]?.prescriptionMedicineCheck.idStatusScheduling === StatusSchedulingEnum.Concluido)
          return 'concluido';
        else if (listPrescriptionCheck?.[-1]?.prescriptionMedicineCheck.idStatusScheduling === StatusSchedulingEnum.Suspenso)
          return 'suspenso';
        else if (isChecking)
          return 'agora';
      }
      else
        return '';
    }
    else if (!listPrescriptionCheck || listPrescriptionCheck.length == 0)
      return 'hide';
    else if (listPrescriptionCheck.length > 0) {
      let [day, month, year] = date.split('/').map(Number);
      let dateStatus = new Date(year, (month - 1), day);

      let verify = listPrescriptionCheck.find(x => {
        let formatDate = new Date(x.prescriptionMedicineCheck.datetimeCheckEstimative);
        return formatDate.getFullYear() == dateStatus.getFullYear()
          && formatDate.getMonth() == dateStatus.getMonth()
          && formatDate.getDate() == dateStatus.getDate()
          && formatDate.getHours() == hour
      });

      if (verify && verify.prescriptionMedicineCheck.idStatusScheduling == StatusSchedulingEnum.Pendente)
        return 'pendente';
      else if (verify && verify.prescriptionMedicineCheck.idStatusScheduling == StatusSchedulingEnum.AAprazar)
        return 'a-prazar';
      else if (verify && verify.prescriptionMedicineCheck.idStatusScheduling == StatusSchedulingEnum.Aprazado)
        return 'aprazado';
      else if (verify && verify.prescriptionMedicineCheck.idStatusScheduling == StatusSchedulingEnum.Concluido)
        return 'concluido';
      else if (verify && verify.prescriptionMedicineCheck.idStatusScheduling == StatusSchedulingEnum.Atrasado)
        return 'atrasado';
      else if (verify && verify.prescriptionMedicineCheck.idStatusScheduling == StatusSchedulingEnum.Suspenso)
        return 'suspenso';
      else if (verify && verify.prescriptionMedicineCheck.idStatusScheduling == StatusSchedulingEnum.Agora)
        return 'agora';
      else return 'hide';
    }

    return 'hide';
  }

  getStatusPrescriptionSolution(listPrescriptionSolutionCheck: PrescriptionSolutionCheckStruct[], idPrescriptionStatus: number, isChecking: boolean, idFrequency: number, listDateTime: DateTimeStruct[], date: string, hour: number): string {
    if (idPrescriptionStatus === PrescriptionStatusEnum.Suspenso)
      return 'hide';
    else if ((!listPrescriptionSolutionCheck || listPrescriptionSolutionCheck.length == 0)
      && listDateTime && listDateTime[0].date == date
      && listDateTime[0].hour[0] == hour) {
      if (idFrequency && idFrequency == FrequencyEnum.agora) {
        if (!isChecking)
          return 'hide';
        else if (listPrescriptionSolutionCheck?.[-1]?.prescriptionSolutionCheck.idStatusScheduling === StatusSchedulingEnum.Concluido)
          return 'concluido';
        else if (listPrescriptionSolutionCheck?.[-1]?.prescriptionSolutionCheck.idStatusScheduling === StatusSchedulingEnum.Suspenso)
          return 'suspenso';
        else if (isChecking)
          return 'agora';
      }
      else
        return '';
    }
    else if (!listPrescriptionSolutionCheck || listPrescriptionSolutionCheck.length == 0)
      return 'hide';
    else if (listPrescriptionSolutionCheck.length > 0) {
      let [day, month, year] = date.split('/').map(Number);
      let dateStatus = new Date(year, (month - 1), day);

      let verify = listPrescriptionSolutionCheck.find(x => {
        let formatDate = new Date(x.prescriptionSolutionCheck.datetimeCheckEstimative);
        return formatDate.getFullYear() == dateStatus.getFullYear()
          && formatDate.getMonth() == dateStatus.getMonth()
          && formatDate.getDate() == dateStatus.getDate()
          && formatDate.getHours() == hour
      });

      if (verify && verify.prescriptionSolutionCheck.idStatusScheduling == StatusSchedulingEnum.Pendente)
        return 'pendente';
      else if (verify && verify.prescriptionSolutionCheck.idStatusScheduling == StatusSchedulingEnum.AAprazar)
        return 'a-prazar';
      else if (verify && verify.prescriptionSolutionCheck.idStatusScheduling == StatusSchedulingEnum.Aprazado)
        return 'aprazado';
      else if (verify && verify.prescriptionSolutionCheck.idStatusScheduling == StatusSchedulingEnum.Concluido)
        return 'concluido';
      else if (verify && verify.prescriptionSolutionCheck.idStatusScheduling == StatusSchedulingEnum.Atrasado)
        return 'atrasado';
      else if (verify && verify.prescriptionSolutionCheck.idStatusScheduling == StatusSchedulingEnum.Suspenso)
        return 'suspenso';
      else if (verify && verify.prescriptionSolutionCheck.idStatusScheduling == StatusSchedulingEnum.Agora)
        return 'agora';
      else return 'hide';
    }

    return 'hide';
  }

  getStatusProcedure(listMedicalProcedureCheck: MedicalProcedureCheckStruct[], isChecking: boolean, isProcedureRecurring: boolean = false, listDateTime: DateTimeStruct[], date: string, hour: number): string {
    if ((!listMedicalProcedureCheck || listMedicalProcedureCheck.length == 0)
      && listDateTime && listDateTime[0].date == date
      && listDateTime[0].hour[0] == hour) {
      if (!isProcedureRecurring) {
        if (!isChecking)
          return 'hide';
        else if (listMedicalProcedureCheck?.[-1]?.idStatusScheduling === StatusSchedulingEnum.Concluido)
          return 'concluido';
        else if (listMedicalProcedureCheck?.[-1]?.idStatusScheduling === StatusSchedulingEnum.Suspenso)
          return 'suspenso';
        else if (isChecking)
          return 'agora';
      }
      else
        return '';
    } else if (!listMedicalProcedureCheck || listMedicalProcedureCheck.length == 0) {
      return 'hide';
    } else if (listMedicalProcedureCheck.length > 0) {
      let [day, month, year] = date.split('/').map(Number);
      let dateStatus = new Date(year, (month - 1), day);
      let verify = listMedicalProcedureCheck.find(x => {
        let formatDate = new Date(x.datetimeCheckEstimative);
        return formatDate.getFullYear() == dateStatus.getFullYear()
          && formatDate.getMonth() == dateStatus.getMonth()
          && formatDate.getDate() == dateStatus.getDate()
          && formatDate.getHours() == hour
      });

      if (verify && verify.idStatusScheduling == StatusSchedulingEnum.Pendente)
        return 'pendente';
      else if (verify && verify.idStatusScheduling == StatusSchedulingEnum.AAprazar)
        return 'a-aprazar';
      else if (verify && verify.idStatusScheduling == StatusSchedulingEnum.Aprazado)
        return 'aprazado';
      else if (verify && verify.idStatusScheduling == StatusSchedulingEnum.Concluido)
        return 'concluido';
      else if (verify && verify.idStatusScheduling == StatusSchedulingEnum.Atrasado)
        return 'atrasado';
      else if (verify && verify.idStatusScheduling == StatusSchedulingEnum.Suspenso)
        return 'suspenso';
      else if (verify && verify.idStatusScheduling == StatusSchedulingEnum.Agora)
        return 'agora';
      else return 'hide';
    }

    return 'hide';
  }

}

